


import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import PropTypes from 'prop-types';

const TinyMCEEditor = ({ 
  value, 
  onChange, 
  readOnly = false, 
  placeholder = '',
  height = 400,
  toolbar,
  plugins,
  menubar = false,
}) => {
  const handleEditorChange = (content, editor) => {
    if (onChange) {
      onChange(content);
    }
  };

  const defaultPlugins = [
    'advlist autolink lists link image',
    'charmap print preview anchor help',
    'searchreplace visualblocks code',
    'insertdatetime media table paste wordcount',
  ];

  const defaultToolbar = 
    'undo redo | formatselect fontsizeselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | link image | code | help';

  return (
    <Editor
      apiKey='y4qiwpjqismb8n0ox89rpjv9gort076zw0yviiamon1rtdps'
      value={value}
      disabled={readOnly}
      init={{
        height,
        menubar,
        placeholder,
        plugins: plugins || defaultPlugins,
        toolbar: toolbar || defaultToolbar,
        fontsize_formats: '8px 10px 12px 14px 16px 18px 20px 24px 28px 32px 36px 48px 64px',
        paste_data_images: true,
        content_style: 'body { font-family: Helvetica, Arial, sans-serif; font-size: 14px; } img:not([style*="width"]) { max-width: 100%; height: auto; }',
        branding: false,
        style_formats: [],
        file_picker_types: 'image',
        file_picker_callback: (cb) => {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');
          input.onchange = function () {
            const file = this.files[0];
            const reader = new FileReader();
            reader.onload = function () {
              const base64 = reader.result;
               cb(base64, { title: file.name });
            };
            reader.readAsDataURL(file);
          };
          input.click();
        },
        setup: (editor) => {
          editor.on('init', () => {
            const paragraphs = editor.dom.select('p');
            paragraphs.forEach(p => {
              const imagesInP = p.querySelectorAll('img');
              if (imagesInP.length > 1) {
                p.classList.add('flex', 'flex-col', 'lg:flex-row', 'justify-between', 'gap-2');
              }
            });
          });
          
   
          editor.on('NodeChange', (e) => {
            if (e.element && e.element.tagName === 'IMG') {
     
              const parentP = e.element.closest('p');
              if (parentP) {
                const imagesInP = parentP.querySelectorAll('img');
                if (imagesInP.length > 1) {
                  parentP.classList.add('flex', 'flex-col', 'lg:flex-row', 'justify-between', 'gap-2');
                }
              }
            }
          });
        },
      }}
      onEditorChange={handleEditorChange}
    />
  );
};

TinyMCEEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  height: PropTypes.number,
  toolbar: PropTypes.string,
  plugins: PropTypes.array,
  menubar: PropTypes.bool,
};

export default TinyMCEEditor;

